

const VisionMissionSection = () => {
  return (
    <section className="w-full flex flex-col py-10 bg-opacity-70 text-[#41220E] bg-transparent">
        <div className="w-full flex items-center justify-start my-8">
            <div className="w-full md:w-[70%] xl:w-[60%] 2xl:w-[50%] h-[320px] bg-[#F5E9D7] rounded-[110px] xs:mx-[20px] mx-[50px] sm:mx-[100px] md:ml-[80px] xs:p-[20px] p-[45px] md:p-[70px] flex flex-col justify-center border-solid border-2 border-[#714E16]">
                <h1 className="font-bold font-playfair text-3xl sm:text-4xl lg:text-4xl xs:mb-2 mb-5">Our Vision</h1>
                <p className="font-medium font-montserrat xs:text-[10px] text-[12px] sm:text-sm md:text-md lg:text-lg">To become the go-to European-style bakery that transforms every visit  into an indulgent yet relaxing experience, blending artisanal  craftsmanship with modern hospitality. 
                    We envision Symphony  Artisanal Bakery & Cafe as a local hub where people connect over  delicious pastries, warm service, and a welcoming atmosphere that feels  like a home away from home.</p>
            </div>
        </div>
        
        <div className="w-full flex items-center justify-end my-8">
            <div className="w-full md:w-[70%] xl:w-[60%] 2xl:w-[50%] h-[320px] bg-[#F5E9D7] rounded-[110px] xs:mx-[20px] mx-[50px] sm:mx-[100px] md:mr-[80px] xs:p-[20px] p-[45px] md:p-[70px] flex flex-col justify-center border-solid border-2 border-[#714E16]">
                <h1 className="font-bold font-playfair text-3xl sm:text-4xl lg:text-4xl xs:mb-2 mb-5">Our Mission</h1>
                <p className="font-medium font-montserrat xs:text-[10px] text-[12px] sm:text-sm md:text-md lg:text-lg">To deliver high-quality, handcrafted European baked goods in a warm,  trendy space where every guest is treated with kindness and a smile. 
                    Our  mission is to bring the essence of European cafés to our customers while  maintaining a relaxed and approachable vibe.</p>
            </div>
        </div>
        
    </section>
  )
}

export default VisionMissionSection
